import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { LanguageService } from './services/language.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'portal-angular1';

  constructor(private languageService: LanguageService) {}

  ngOnInit(): void {
    this.languageService.applyHostDefaultLanguageIfNeeded();
  }
}
